import Swal from 'sweetalert2'
import {
    IS_LOADING_CREATE_TYPE_OF_REPORT,
    CREATE_TYPE_OF_REPORT,
    GET_TYPE_OF_REPORT,
    IS_LOADING_GET_TYPE_OF_REPORT,
    IS_LOADING_TYPE_OF_REPORT,
    TYPE_OF_REPORT,
    DELETE_REPORT,
    IS_LOADING_ONE_TYPE_OF_REPORT,
    GET_LIMIT_REPORTS,
    IS_LOADING_GET_LIMIT_REPORTS,
    DELETE_LIMIT_REPORT,
    GET_LIMIT_REPORT,
    IS_LOADING_BANE_LIMITS,
    CREATE_BANE_LIMIT,
    DELETE_BANE_LIMIT, EDIT_TYPE_OF_REPORT, IS_LOADING_LIST_REPORTS_COMMUNITIES, LIST_REPORTS_COMMUNITIES, CHANGE_REPORT_COMMUNITY,
    GET_BAN_LIMIT_LIST, GET_ACTUAL_LIMIT_BANE, GET_LIMIT_BANE, EDIT_BANE_LIMIT, ACTUAL_BANE_LIMIT, IS_LOADING_LIST_REPORTS, LIST_REPORTS, CHANGE_REPORT, CHANGE_REPORT_CONTENT, IS_LOADING_LIST_REPORTS_CONTENT, LIST_REPORTS_CONTENT, ClEAN_LIST_REPORTS,

} from './types'
import {
    urlServer
} from '../../config/GlobalConstant'
import inMemoryJWT from '../../auth/inMemoryJwt';

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000
})
///Report of post or user Management

export const createTypeOfReport = (report, history) => async dispatch => {


    await fetch(`${urlServer}admintypeofreports/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(report)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()

            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_GET_TYPE_OF_REPORT
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: CREATE_TYPE_OF_REPORT,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getTypeOfReports = () => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_GET_TYPE_OF_REPORT
    });

    await fetch(`${urlServer}admintypeofreports/get-all`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    

    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_TYPE_OF_REPORT,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}

export const getReportType = (id) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_ONE_TYPE_OF_REPORT
    });

    await fetch(`${urlServer}api/typeofreport/id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: TYPE_OF_REPORT,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}

export const updateReport = (reportUpdated, history, index) => async dispatch => {

    await fetch(`${urlServer}admintypeofreports/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(reportUpdated)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_GET_TYPE_OF_REPORT
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: EDIT_TYPE_OF_REPORT,
                    payload: {
                        index: index,
                        data: respJson.data
                    }
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const deleteReport = (id, index) => async dispatch => {

    await fetch(`${urlServer}admintypeofreports/delete`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            typeID: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_GET_TYPE_OF_REPORT
            });
            if (respJson.success) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_REPORT,
                    payload: index
                });
            } else {
                if (respJson.error.code ==="ERR013") {
                    Toast.fire({
                        icon: 'error',
                        title: 'Hay reportes que estan usando este tipo de reporte'
                    })
                }
            }


        })
        .catch(error => {
            console.log()
        })
}

export const createLimitReport = (reportLimit, history) => async dispatch => {

    await fetch(`${urlServer}api/reportinglimit/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(reportLimit)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                history.push('/SeeLimitsReportAdmin')
            }
            if (respJson.success === false) {
                history.push('/SeeLimitsReportAdmin')
            }

        })
        .catch(error => {
            console.log()
        })
}

export const getLimitReports = (reportsLimit) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_GET_LIMIT_REPORTS
    });
    await fetch(`${urlServer}adminparameters/get`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_LIMIT_REPORTS,
                payload: {
                    limitRejectedRequests: respJson.data.limitRejectedRequests,
                    limitAmountOfReports: respJson.data.limitAmountOfReports,
                    limitAmountOfInfractions: respJson.data.limitAmountOfInfractions,
                    shippingCost: respJson.data.shippingCost,
                    ecoPrice: respJson.data.ecoPrice
                }
            });

        })
        .catch(error => {
            console.log()
        })
}

export const getLimitReport = (idReport) => async dispatch => {

    await fetch(`${urlServer}api/reportinglimit/id`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: idReport })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_LIMIT_REPORT,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}

export const editLimitReport = (reportLimit, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}adminparameters/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(reportLimit)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Registro actualizado'
                })
                history.push('/Admin/SeeLimitsReportAdmin')
            }

        })
        .catch(error => {
            console.log()
        })
}


export const createBaneLimit = (baneLimit, history, isLimit, baneActualLimit) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/banlimit/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(baneLimit)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                if (isLimit === false) {
                    dispatch({
                        type: IS_LOADING_BANE_LIMITS
                    });

                    dispatch({
                        type: CREATE_BANE_LIMIT,
                        payload: baneLimit
                    });
                }
                if (isLimit === true && baneActualLimit === null) {
                    dispatch({
                        type: IS_LOADING_BANE_LIMITS
                    });

                    dispatch({
                        type: GET_ACTUAL_LIMIT_BANE,
                        payload: baneLimit
                    });
                }

                if (isLimit === true && baneActualLimit !== null) {
                    dispatch({
                        type: IS_LOADING_BANE_LIMITS
                    });

                    dispatch({
                        type: ACTUAL_BANE_LIMIT,
                        payload: { baneLimit, baneActualLimit }
                    });
                }

            }
        })
        .catch(error => {
            console.log()
        })
}

export const getBaneLimits = () => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: GET_BAN_LIMIT_LIST,
        payload: [{}]
    });
    await fetch(`${urlServer}api/banlimit/`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
        

        })
        .catch(error => {
            console.log()
        })
}

export const getBaneLimit = (id) => async dispatch => {

    await fetch(`${urlServer}api/banlimit/id`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ id: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_LIMIT_BANE,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}

export const editBaneLimit = (baneLimit, index, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/banlimit/update-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(baneLimit)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_BANE_LIMITS
                });

                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: EDIT_BANE_LIMIT,
                    payload: { baneLimit, index }
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getActualBaneLimit = () => async dispatch => {

    await fetch(`${urlServer}api/banlimit/actual-limit`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    

    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_BANE_LIMITS
            });
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_ACTUAL_LIMIT_BANE,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}

export const deleteBaneReport = (id, index) => async dispatch => {
    console.log()

    await fetch(`${urlServer}api/banlimit/delete-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_BANE_LIMITS
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DELETE_BANE_LIMIT,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getListReportsContent = (status) => async dispatch => {

    await fetch(`${urlServer}admincontentreports/get-status`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ status })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_LIST_REPORTS_CONTENT
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: LIST_REPORTS_CONTENT,
                    payload: respJson.data
                });
            }else{
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: LIST_REPORTS_CONTENT,
                    payload: []
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const getListReports = (status) => async dispatch => {

    await fetch(`${urlServer}adminentityreports/get-status`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            status
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if(respJson.success){
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_LIST_REPORTS
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: LIST_REPORTS,
                    payload: respJson.data
                });
            }else{
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_LIST_REPORTS
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: LIST_REPORTS,
                    payload: []
                });
            }
         

        })
        .catch(error => {
            console.log()
        })
}

export const getListReportsZones = (listReport) => async dispatch => {

    await fetch(`${urlServer}roomzonereports/get-community-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(listReport)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_LIST_REPORTS
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: LIST_REPORTS,
                    payload: respJson.data
                });
            } else {
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: LIST_REPORTS,
                    payload: []
                });
            }

        })
        .catch(error => {
            console.log()
        })
}
export const cleanListReportsZones = () =>  dispatch => {

    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: ClEAN_LIST_REPORTS
    });
}

export const changeReportAdminZones = (changeReport) => async dispatch => {

    await fetch(`${urlServer}roomzonereports/change-status`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(changeReport)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_LIST_REPORTS
            });
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: CHANGE_REPORT,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}

export const changeReportContentAdmin = (status, id) => async dispatch => {

    await fetch(`${urlServer}admincontentreports/change-status`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ status, contentReportID: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_LIST_REPORTS
            });
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: CHANGE_REPORT_CONTENT,
                payload: id
            });

        })
        .catch(error => {
            console.log()
        })
}

export const changeReportAdmin = (status,entityReportID) => async dispatch => {

    await fetch(`${urlServer}adminentityreports/change-status`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            status,
            entityReportID,

        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_LIST_REPORTS
            });
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: CHANGE_REPORT,
                payload: entityReportID
            });

        })
        .catch(error => {
            console.log()
        })
}

//communities reports

export const getStateCommunityReportAdmin = (reportState) => async dispatch => {

    await fetch(`${urlServer}api/communityreport/state`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ reportState: reportState })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_LIST_REPORTS_COMMUNITIES
            });
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: LIST_REPORTS_COMMUNITIES,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}

export const changeCommunityStateReportAdmin = (stateReport, index) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/communityreport/change-state`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(stateReport)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_LIST_REPORTS_COMMUNITIES
            });
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: CHANGE_REPORT_COMMUNITY,
                payload: index
            });

        })
        .catch(error => {
            console.log()
        })
}


